import type { Location } from "common/types";
import { extract, toAsyncResult } from "vsto/utils";
import { useVstoInterop } from "vsto/VstoInterop";

export function useMailboxItemLocation(): {
  setAsync: Location["setAsync"];
} {
  function setAsync(location: string, options?, callback?) {
    const [, cb] = extract(options, callback);
    toAsyncResult(useVstoInterop().setCurrentItemLocation(location)).then(cb);
  }

  return {
    setAsync,
  };
}
